// extracted by mini-css-extract-plugin
export var container = "CardWithTextMask-module--container--KJpk2";
export var description = "CardWithTextMask-module--description--6MZJM";
export var title = "CardWithTextMask-module--title--k9Zpk";